import { render, staticRenderFns } from "./RegisterHealthYN.vue?vue&type=template&id=570469de"
import script from "./RegisterHealthYN.vue?vue&type=script&lang=js"
export * from "./RegisterHealthYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports